import * as React from 'react';
import {Button, ButtonProps} from "@mui/material";

const GetHelpButton = (props: ButtonProps) => {
    return <Button href={'https://mycontentdash.com/help'} {...props}>Get Support</Button>;
}

export default GetHelpButton;